module.exports = __webpack_public_path__ + "img/7.7e79f776.jpg";